import { gql } from "@apollo/client";

export const GET_REFERRALS_BY_USER_NAME = gql`
  query SearchReferralByName($name: String!, $orgId: String!) {
    searchReferralByName(name: $name, orgId: $orgId) {
      id
      from
      user {
        id
        firstName
        lastName
        email
      }
      userId
      eligibilityStatus
      serviceId
      serviceName
      orgId
      status
      isSelfReferral
    }
  }
`;
